import axiosInstance from "../../api/axiosInstance";

export const fetchRoomSetsAPI = async () => {
  const roomSetsList = await axiosInstance.get("roomsets/get-all-room-sets");

  return roomSetsList.data;
};
